import { useAuthStore } from '@/store/auth-store';
import type { AppFeatures } from '@/types/user';

const DEFAULT_APP_FEATURES: AppFeatures = {
  enablePrivateProfile: true,
  enableEngagementLibrary: true,
  enableProBookings: true,
};

/**
 * Returns the feature flags the backend computed for the current user (`appFeatures` on
 * `/api/v1/users/me`). A flag restricts the UI only when it is explicitly `false`.
 */
export function useAppFeatures(): AppFeatures {
  const { user } = useAuthStore();

  return { ...DEFAULT_APP_FEATURES, ...user?.appFeatures };
}
